import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownOrganizationsMulti extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            organization: []
        };

    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.hadlerAddAllOrganizations !== prevProps.hadlerAddAllOrganizations) {
            if (this.props.hadlerAddAllOrganizations === true) {
                this.addAllOrganizations()
            }
        }
    }

    addAllOrganizations() {
        this.props.handlerFromParent(this.state.organization);
    }

    componentDidMount() {

        if (AxiosHeader.getConfig() !== null) {

            const url = process.env.REACT_APP_API_URL + "/Global/Organizations";

            apiClient.get(url, AxiosHeader.getConfig())
                .then(res => {
                    const organization = res.data;
                    const loading = false;
                    this.setState({organization, loading});
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);

                });
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }
    }

    render() {
        return (
            <Select
                placeholder="Organization Select"
                name="organizationSelect"
                autoFocus={false}
                multi={true}
                isSearchable={true}
                disabled={this.props.disabled}
                value={this.props.contentOrganizationSelected}
                options={this.state.organization}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownOrganizationsMulti = connect(mapStateToProps)(DropDownOrganizationsMulti);
const connectedDropDownOrganizationsMultiTrans = withNamespaces('common')(connectedDropDownOrganizationsMulti);
export {connectedDropDownOrganizationsMultiTrans as DropDownOrganizationsMulti};